import { GQL } from '../graphQl'
export const GetMaterialMasterDataQuery =
  () => GQL`query GetMaterialMasterDataQuery($jump: Int, $perPage: Int, $conditions: core_material_master_bool_exp, $collaborator: Boolean!, $orderBy: [core_material_master_order_by!]) {
  core_material_master_aggregate(where: $conditions) {
    aggregate {
      count
    }
  }
  core_material_master(where: $conditions, limit: $perPage, offset: $jump, order_by: $orderBy) {
    workflow_template {
      name
      id
    }
      setup_time
      setup_time_duration_type
    resource_type_value {
      id
      name
    }
    type
    dimension
    volume
    unit_of_volume
    custom_material_id
    erp_material_id
    id
    material_type_value {
      id
      name
    }
    gross_weight
    inventory
    lead_time
    material_storage_location {
      name
    }
    material_description
    material_group
    material_group_details {
      name
      id
    }
    ongoing_lifecycle_workflow_id
    ongoing_lifecycle_workflow {
      current_instance_step {
        instance_step_assignees {
          user_id
          target_tenant_id
        }
        workflow_step {
          core_user_group {
            core_user_group_members {
              user_id
            }
          }
        }
      }
    }
    material_name
    material_type
    plm_material_id
    plm_record_id
    inventory
    effective_date
    status
    sequence_id
    storage_loc
    unit_cost
    unit_of_material
    material_unit_details {
      name
      id
    }
    unit_sale_price
    weight_unit
    material_weight_details {
      name
      id
    }
    product_code
    material_product_code {
      id
      sequence_id
      product_code
    }
    tag_materials {
      tag {
        name
        id
        parent_id
      }
    }
    material_source {
      id
      source
    }
    material_document_associations(where: {core_document: {deleted: {_eq: false}}}) {
      material_id
      document_id
        core_user{
        first_name
        last_name
      }
      created_on
      core_document_version {
        id
        blob_key
        doc_name
        doc_size
        doc_type
        doc_ext
        thumbnail_blob_key
        state
      }
    }
    blob_reference_key
    material_status {
      id
      status
    }
    material_default_vendor {
      id
      company_name
    }
    vendor_materials(where: {tenant_company_association: {workflow_instance: {state_value: {name: {_eq: "COMPLETED"}}}, status: {_eq: 1}}}) @skip(if: $collaborator) {
      moq
      lead_time
      vendor_materials_pricing_tiers {
        min_quantity
        max_quantity
        unit_price
      }
      tenant_company_association {
        target_tenant {
          id
          company_name
        }
      }
    }
    job_order_material_links @skip(if: $collaborator) {
      form_id
      workflow_instance {
        state_value {
          name
        }
      }
    }
    core_form {
      id
      template_version {
        active
        version_id
        id
        template_fields {
          autogenerated
          caption
          custom_list_id
          field_id
          field_name
          field_type_id
          fixed
          required
          template_version_id
          form_field {
            key
          }
        }
      }
    }
  }
}
`
export const GetJobOrderMaterialLinksQuery = () => GQL`query GetJobOrderMaterialLinksQuery($limit: Int!, $offset: Int!, $conditions: job_order_material_links_bool_exp, $orderBy: [job_order_material_links_order_by!]) {
  job_order_material_links_aggregate(where: $conditions) {
    aggregate {
      count(columns: id)
    }
  }
  job_order_material_links(where: $conditions, limit: $limit, offset: $offset, order_by: $orderBy) {
    bar_code_blob_key
    form_id
    material_id
    core_form {
      project_id
      default_sequence
      template_version {
        template_id
      }
      forms_company_list {
        core_tenant {
          company_name
        }
      }
      forms_material_lists{
        material_id
        priority
        quantity
        core_material{
          material_name
        }
      }
    }
    workflow_instance {
      created_on
      id
      state_value {
        name
      }
      template_version_id
      transition_history(order_by: {end_date: desc}, limit: 1) {
        id
        form_id
        qc_form{
          status
        }
        current_workflow_step {
        resource_group
         core_user_group{
          core_user_group_members{
            core_user{
              first_name
              last_name
            }
          }
        }
        qc_parent_step_id
        qc_form_template_id
          id
          name
        }
      }
      current_instance_step {
        projected_end_date
        instance_step_resources {
          resource_id
          factory_resource_instance {
            core_material_master {
              material_name
              id
            }
          }
        }
        core_attachments{
          file_name
        }
       instance_step_assignees{
          user_id
        }
        workflow_step {
            id
          end_step
          start_step
          name
          qc_parent_step_id
          workflow_step_resources_associations {
            resource_id
          }
          trigger_actions{
            trigger_timing
            mandatory
            
          }
          next_transition {
            id
            name
        next_workflow_stage{
          id
        }
          }
          core_user_group {
            core_user_group_members {
            user_id
              core_user {
                first_name
                last_name
              }
            }
          }
        }
      }
      core_material_master {
        material_name
        id
        material_product_code {
          product_code
        }
      }
    }
  }
}
`
export const getResourceTypesQuery = () => GQL`query GetResourceTypes {
  custom_list_values(where: {custom_list: {name: {_eq: "RESOURCE_TYPES"}, system_generated: {_eq: true}, tenant_id: {_is_null: true}}}) {
    id
    name
  }
}`

export const GetMaterialMasterDataQueryForCsv =
  () => GQL`query GetMaterialMasterDataQueryForCsv($jump: Int, $perPage: Int, $conditions: core_material_master_bool_exp) {
  core_material_master_aggregate(where: $conditions) {
    aggregate {
      count
    }
  }
  core_material_master(
    where: $conditions
    limit: $perPage
    offset: $jump
    order_by: {custom_material_id: desc}
  ) {
    type
    custom_material_id
    erp_material_id
    id
    gross_weight
    inventory
    lead_time
    material_storage_location {
      name
    }
    material_description
    material_group
    material_name
    material_type
    plm_material_id
    plm_record_id
    inventory
    effective_date
    status
    storage_loc
    unit_cost
    unit_of_material
    material_unit_details {
      name
      id
    }
    unit_sale_price
    weight_unit
    material_weight_details {
      name
      id
    }
    product_code
    material_product_code {
      id
      product_code
    }
    tag_materials {
      tag {
        name
        id
        parent_id
      }
    }
    material_source {
      id
      source
    }
    material_status {
      id
      status
    }
        material_document_associations(where: {core_document: {deleted: {_eq: false}}}) {
      material_id
      document_id
      core_document {
        id
        blob_key
        doc_name
        doc_size
        doc_type
        thumbnail_blob_key
        state
        associated_versions(order_by: {created_on: asc}) {
          id
          blob_key
          doc_name
          doc_size
          doc_type
          thumbnail_blob_key
          state
        }
      }
    }
   core_form {
      template_version_id
        forms_metadata_by_id {
          field_id
          form_id
          time_value
      point_value
      int_value
      date_value
      bool_value
      string_value
        }
        forms_config_lists {
          field_id
          form_id
          form_config_list
        }
      }
  }
}
`

export const resourceGroup =
  () => GQL`query fetchingMaterialGroup($name: String) {
  custom_list_values(
    where: {custom_list: {name: {_eq: $name}}, deleted: {_eq: false}}
  ) {
    id
    name
  }
}`

export const GetSingleMaterialMasterDataQuery =
  () => GQL`query GetSingleMaterialMasterDataQuery(
  $id: uuid
  ) {
  core_material_master(
    where: {id:{_eq : $id}}
  ) {
    type
    custom_material_id
    erp_material_id
    id
    gross_weight
    inventory
    lead_time
    material_storage_location {
    name
    }
    material_description
    material_group
    material_name
    material_type
    material_type_value {
      id
      name
    }
    plm_material_id
    plm_record_id
    inventory
    effective_date
    status
    storage_loc
    unit_cost
    unit_of_material
    material_unit_details {
      name
      id
    }
    unit_sale_price
    weight_unit
    material_weight_details {
      name
      id
    }
    product_code
    material_product_code {
      id
      product_code
    }
    tag_materials {
      tag {
        name
        id
        parent_id
      }
    }
    material_source {
      id
      source
    }
   material_document_associations(where: {core_document: {deleted: {_eq: false}}}) {
      material_id
      document_id
      core_document {
        id
        blob_key
        doc_name
        doc_size
        doc_type
        thumbnail_blob_key
        state
        associated_versions(order_by: {created_on: asc}) {
          id
          blob_key
          doc_name
          doc_size
          doc_type
          thumbnail_blob_key
          state
        }
      }
    }
    blob_reference_key
    material_status {
      id
      status
    }
    core_form {
      id
      template_version {
        active
        version_id
        id
        template_fields {
          autogenerated
          caption
          custom_list_id
          field_id
          field_name
          field_type_id
          fixed
          required
          template_version_id
          form_field {
            key
            __typename
          }
          __typename
        }
        __typename
      }
    }
  }
}
`
export const GetMaterialMasterForBomQuery =
  () => GQL`query GetMaterialMasterForBomQuery(
  $jump: Int,
  $perPage: Int,
  $conditions: core_material_master_bool_exp
  ) {
  core_material_master_aggregate(where: $conditions){
    aggregate {
      count
    }
  }
  core_material_master(
    where: $conditions
    limit: $perPage
    offset: $jump
    order_by: {custom_material_id: desc}
  ) {
    workflow_template {
     name
     id
    }
    custom_material_id
    erp_material_id
    id
    lead_time
    material_description
    material_group
    type
    material_name
    material_type
    plm_material_id
    unit_of_material
    unit_cost
    unit_sale_price
    core_form {
      id
      }
    material_unit_details {
      name
      id
    }
    product_code
    material_product_code {
      id
      product_code
    }
  }
}
`

export const CreateMaterialMaster = () => GQL`mutation CreateMaterialMaster(
  $custom_material_id: String,

  $form_id: uuid,
  $type: Int,
  $gross_weight: float8,
  $inventory: Int,
  $lead_time: Int,
  $material_description: String,
  $material_group: Int,
  $resource_group: Int,
  $material_name: String,
  $others: jsonb,
  $parent_id: Int,
  $plm_material_id: String,
  $plm_record_id: String,
  $product_code: uuid,
  $effective_date: date,
  $storage_loc: Int,
  $unit_cost: float8,
  $unit_of_material: Int,
  $unit_sale_price: float8,
  $resource_state: Int,
  $weight_unit: Int) {
  insert_core_material_master_one(
    object: {
      custom_material_id: $custom_material_id,
      form_id: $form_id,
      gross_weight: $gross_weight,
      inventory: $inventory,
      lead_time: $lead_time,
      material_description: $material_description,
      material_group: $material_group,
      resource_group: $resource_group,
      material_name: $material_name,
      type: $type,
      resource_state: $resource_state,
      others: $others,
      parent_id: $parent_id,
      plm_material_id: $plm_material_id,
      plm_record_id: $plm_record_id,
      product_code: $product_code,
      effective_date: $effective_date,
      unit_cost: $unit_cost,
      storage_loc: $storage_loc,
      unit_of_material: $unit_of_material,
      unit_sale_price: $unit_sale_price,
      weight_unit: $weight_unit,
    }
  ) {
    id
  }
}`

export const UpdateMaterialWorkflowLinkMutation = () =>
  GQL`mutation UpdateMaterialMasterDataQuery($id: uuid, $workflowTemplateId: uuid) {
    update_core_material_master(
    where: {id: {_eq: $id}}
    _set: {workflow_template_id: $workflowTemplateId}
    ) {
    affected_rows
    }
  }`

export const AddAlternateMaterialQuery = () => GQL`mutation AddAlternateMaterial($alternate_material_ids: [uuid!]!, $material_id: uuid!, $reason: String!, $start_step_id: uuid!, $step_assignees: [uuid!]!) {
  add_alternate_materials(alternate_material_ids: $alternate_material_ids, material_id: $material_id, reason: $reason, start_step_id: $start_step_id, step_assignees: $step_assignees) {
    message
  }
}`

export const AlternateMaterialsQuery = () => GQL`query AlternateMaterials($id: uuid!) {
  alternate_materials(where: {material_id: {_eq: $id}}) {
    alternate_material {
      id
      custom_material_id
      material_name
    }
    deleted
    workflow_instance {
      id
      created_on
      state_value {
        name
      }
      workflow_stage {
        id
        name
      }
      workflow_version {
        workflow_template {
          id
          name
        }
      }
    }
  }
}`
export const UpdateMaterialMasterDataQuery =
  () => GQL`mutation UpdateMaterialMasterDataQuery(
  $id: uuid,
  $type: Int,
  $gross_weight: float8,
  $inventory: Int,
  $lead_time: Int,
  $material_description: String,
  $material_group: Int,
  $material_name: String,
  $effective_date: date,
  $storage_loc: Int,
  $unit_cost: float8,
  $setup_time: Int,
  $setup_time_duration_type: Int,
  $unit_of_material: Int,
  $unit_sale_price: float8,
  $weight_unit: Int,
  $product_code: uuid,
  $workflow_template_id: uuid,
    $plm_material_id: String,
  ) {
  update_core_material_master(
    where: {id: {_eq: $id}}
    _set: {
      type: $type,
      gross_weight: $gross_weight,
      inventory: $inventory,
      lead_time: $lead_time,
      material_description: $material_description,
      material_group: $material_group,
      material_name: $material_name,
      effective_date: $effective_date,
      storage_loc: $storage_loc,
      unit_cost: $unit_cost,
      unit_of_material: $unit_of_material,
      unit_sale_price: $unit_sale_price,
      weight_unit: $weight_unit,
      product_code: $product_code,
      setup_time: $setup_time,
      setup_time_duration_type: $setup_time_duration_type,
      plm_material_id:$plm_material_id
      workflow_template_id: $workflow_template_id
    }
  ) {
    affected_rows
  }
}
`
export const insertMaterialMasterDataQuery =
  () => GQL`mutation insertMaterialMasterDataQuery(
    $objects: [core_material_master_insert_input!] = {}
  ) {
  insert_core_material_master(objects: $objects) {
    affected_rows
  }
}`

export const getProductsUsingMaterialQuery =
  () => GQL`query getProductsUsingMaterialQuery($material_id: uuid) {
  core_material_master(where: {id: {_eq: $material_id}}) {
    bom_material_items(distinct_on: bom_id) {
      quantity
      unit_size
      core_bom {
        name
        product_bom {
          product_code
        }
        state
      }
    }
    material_product_code {
      product_code
    }
  }
}`
export const getProjectLevelProductsUsingMaterialQuery =
  () => GQL`query getProjectLevelProductsUsingMaterialQuery($material_id: uuid, $project_id:uuid) {
  core_material_master(where: {id: {_eq: $material_id}}) {
    bom_material_items(
      distinct_on: bom_id
      where: {core_bom: {project_id: {_eq: $project_id}}}
    ) {
      core_bom {
        project_id
        name
        product_bom {
          product_code
        }
      }
    }
    material_product_code {
      product_code
    }
  }
}`

export const UpdateMaterialStatusQuery =
  () => GQL`mutation UpdateMaterialStatusQuery($id:uuid! , $status:Int!) {
  update_core_material_master_by_pk(pk_columns: {id: $id}, _set: {status: $status}) {
    id
    status
  }
}`

export const ChangeResourceStatusQuery =
  () => GQL`mutation ChangeResourceStatusQuery ($id:uuid! , $status:Int!) {
  update_core_material_master_by_pk(pk_columns: {id: $id}, _set: {resource_state: $status}) {
    id
    status
  }
}`

export const unitOfMaterial = () => GQL`query fetchingUnitOfmaterial {
  custom_list_values(
    where: {custom_list: {name: {_eq: "Unit of Material"}}, deleted: {_eq: false}}
  ) {
    id
    name
  }
}`

export const weightUnit = () => GQL`query fetchingWeightUnit {
  custom_list_values(
    where: {custom_list: {name: {_eq: "Weight Unit"}}, deleted: {_eq: false}}
  ) {
    id
    name
  }
}
`

export const materialGroup = () => GQL`query fetchingMaterialGroup {
  custom_list_values(
    where: {custom_list: {name: {_eq: "Material Group"}}, deleted: {_eq: false}}
  ) {
    id
    name
  }
}`

export const addressLocation = () => GQL`query addressLocation {
  address_locations(where: {deleted: {_eq: false}}) {
    id
    name
  }
}`

export const attchMaterilIdToDocQuery =
  () => GQL`mutation attchMaterilIdToDocQuery($material_id: uuid , $docId: uuid! ) {
  update_core_documents_by_pk(
    pk_columns: {id: $docId}
    _set: {material_id: $material_id}
  ) {
    checked_out_by
    created_by
    doc_type
    id
    material_id
  }
}`
export const attachDocToMaterailMutation = () => GQL`mutation attachDocToMaterailMutation ($data: [material_document_association_insert_input!]!) {
  insert_material_document_association(objects: $data) {
    affected_rows
  }
}`
// export const attchMaterilIdToDocQuery = () => GQL`mutation attchMaterilIdToDocQuery($material_id: Int, $docIds: uuid! ) {
//   update_core_documents(
//     _set: {material_id: $material_id}
//     where: {id: {_eq: $docIds}}
//   ) {
//     affected_rows
//     returning{
//       id
//       material_id
//     }
//   }
// }`
export const removeAttachmentsDocQuery =
  () => GQL`mutation removeAttachmentsDocQuery($materialId: uuid = "", $docIds: [uuid!] = "") {
  delete_material_document_association(
    where: {material_id: {_eq: $materialId}, document_id: {_in: $docIds}}
  ) {
    affected_rows
    returning {
      material_id
    }
  }
}`

export const checkMaterialID =
  () => GQL`query check_material_ID($materialID: String!) {
  core_material_master(where: {custom_material_id: {_eq: $materialID}}) {
    id
    custom_material_id
  }
}
`
export const upadateMaterialFormsQuery =
  () => GQL`mutation upadateMaterialFormsQuery($materialId: uuid , $formId: uuid = "") {
  update_core_material_master(where: {id: {_eq: $materialId}}, _set: {form_id: $formId}) {
    affected_rows
    returning {
      id
    }
  }
}

`

export const createMaterialMasterMutation = () => GQL`mutation createMaterialMaster($customFieldInput: [customFieldData], $docInput: [material_document_input!], $materialInput: material_create_input!, $productCodeInput: String, $tagInput: [uuid!], $sequenceInput: [sequence_create_input], $productCodeSequenceInput: [product_code_sequence_create_input], $sequenceTemplateId: uuid, $productCodeSequenceTemplateId: uuid, $sequenceAsName: Boolean) {
  create_material_master(custom_fields_input: $customFieldInput,
  material_input: $materialInput,
  product_code_input: $productCodeInput,
  tag_input: $tagInput,
  doc_input: $docInput,
  sequence_input: $sequenceInput,
  product_code_sequence_input: $productCodeSequenceInput,
 sequence_template_id: $sequenceTemplateId,
 product_code_sequence_template_id: $productCodeSequenceTemplateId,
 sequence_as_name: $sequenceAsName) {
    message
  }
}`

export const CreateLinkProductCodeMutation = () => GQL`mutation CreateLinkProductCode($material_id: uuid!, $product_code_sequence_template_id: uuid!, $product_code_sequence_input: [product_code_sequence_create_input!]!) {
  create_link_product_code(material_id: $material_id, product_code_sequence_template_id: $product_code_sequence_template_id, product_code_sequence_input: $product_code_sequence_input) {
    message
    product_code_id
    inserted_product_code_id
  }
}`

export const checkForAnyRunningInstancesQuery = () => GQL`query checkForAnyRunningInstances($id: uuid!) {
  job_order_material_links(
    where: {core_form: {forms_material_lists: {status: {_neq: 4}}}, material_id: {_eq: $id}}
  ) {
    id
  }
}
`

export const GetMaterialInventoryDetailsQuery = () => GQL`query GetMaterialInventoryDetails($conditions: core_forms_bool_exp!, $materialId: uuid!) {
  core_forms(where: {
    _and: [
      $conditions,
      { forms_material_list: { material_id: { _eq: $materialId } } }
    ]
  }) {
    id
    sequence_value
    template_version_id
    updated_on
    project_id
    template_version {
      core_form_template {
        id
        name
      }
    }
    forms_company_lists(where: {template_field: {field_name: {_eq: "requesting_company"}}}) {
      core_tenant {
        company_name
      }
    }
    forms_material_lists(where: {material_id: {_eq: $materialId}}) {
      quantity
    }
  }
}
`

export const getMaterialCustomList = () => GQL`query GetMaterialCustomList {
 custom_list_values(where: {custom_list: {name: {_eq: "Material Type"}, system_generated: {_eq: true}, tenant_id: {_is_null: true}}}) {
    id
    name
  }
}`

export const updateDefaultVendor = () => GQL`mutation MyMutation($materialId: uuid!, $vendorId: uuid!) {
  update_core_material_master(where: {id: {_eq: $materialId}}, _set: {default_vendor: $vendorId}) {
    affected_rows
  }
}`
export const getMaterialDefualtVendorQuery = () => GQL`query getMaterialDefualtVendorQuery($materialIds: [uuid]) {
  core_material_master(where:{id:{_in:$materialIds}} ){
    id
    material_default_vendor {
      id
    }
  }
}`
export const getWfListBasedOnIdQuery = () => GQL`
query getWfListBasedOnIdQuery($bomId: uuid, $materialId: uuid, $documentId: uuid, $category: Int) {
  get_applicable_workflows(bom_id: $bomId, material_id: $materialId, document_id: $documentId, category: $category) {
    message {
      name
      template_id
      template_type
      template_version_id
      template_type_value
      start_steps {
        id
        name
        duration
        duration_type
        user_group {
          id
          core_user_group_members {
            user_id
          }
        }
      }
    }
  }
}`

export const CheckCustomMaterialIdExistenceQuery = () => GQL`query CheckCustomMaterialIdExists($customMaterialId: String!) {
  core_material_master(where: {custom_material_id: {_eq: $customMaterialId}}) {
    id
    material_name
  }
}`
export const GetAllWFLifeCycle = () => GQL`query GetAllLifecyleWf($id: uuid!) {
  workflow_instances(where: {material_id: {_eq: $id}, category: {_in: [2, 3] }}) {
    id
    workflow_version {
      workflow_template {
        name
      }
    }
    state_value{
      name
    }
    created_by_user {
      first_name
      last_name
    }
    created_on
    transition_history(limit: 1, order_by: {end_date: desc}) {
      end_date
    }
  }
}`
